// Domain related to conditions in capture reply from backend

export interface OrderConditions {
  acknowledgementRequired?: boolean;
  conditions?: Conditions;
  estimateNotAvailable?: boolean;
  explicitAcknowledgementRequired?: boolean;
  hardStop?: boolean;
  regulatoryCustomLogicRequired?: boolean;
  regulatoryAcknowledgementRequired?: boolean;
  success?: boolean;
  systemIssuePresent?: boolean;
}

export interface Conditions {
  ACKNOWLEDGEMENTREQUIRED?: Array<ConditionDetails>;
  ACTIONREQUIRED?: Array<ConditionDetails>;
  EXPLICITACKNOWLEDGEMENTREQUIRED?: Array<ConditionDetails>;
  INFORMATIONAL?: Array<ConditionDetails>;
  REGULATORYCUSTOMLOGICREQUIRED?: Array<ConditionDetails>;
  REGULATORYACKNOWLEDGEMENTREQUIRED?: Array<ConditionDetails>;
  SYSTEMISSUE?: Array<ConditionDetails>;
  UNKNOWN?: Array<ConditionDetails>;
}

export interface ConditionDetails {
  acknowledgement?: AcknowledgementStatus;
  code: string;
  description: string;
  id: string;
  orderIndex?: number;
  type: keyof Conditions;
}

export enum AcknowledgementStatus {
  USER_ACCEPTED = 'USER_ACCEPTED',
  SYSTEM_ACCEPTED = 'SYSTEM_ACCEPTED',
  NOT_ACCEPTED  = 'NOT_ACCEPTED'
}

// This uses the same name as the relevant enum on the backend
export enum ConditionCategoryType {
  ACKNOWLEDGEMENTREQUIRED = 'ACKNOWLEDGEMENTREQUIRED',
  ACTIONREQUIRED = 'ACTIONREQUIRED',
  EXPLICITACKNOWLEDGEMENTREQUIRED = 'EXPLICITACKNOWLEDGEMENTREQUIRED',
  INFORMATIONAL = 'INFORMATIONAL',
  REGULATORYCUSTOMLOGICREQUIRED = 'REGULATORYCUSTOMLOGICREQUIRED',
  SYSTEMISSUE = 'SYSTEMISSUE',
  UNKNOWN = 'UNKNOWN'
}
